'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AuthService = require('./AuthService');

var _AuthService2 = _interopRequireDefault(_AuthService);

var _OktaContext = require('./OktaContext');

var _OktaContext2 = _interopRequireDefault(_OktaContext);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Security = function Security(props) {
  var initialAuthService = (0, _react.useMemo)(function () {
    // don't keep spawning new service instances if this component rerenders
    return props.authService || new _AuthService2.default(props);
  }, [props]);

  var _useState = (0, _react.useState)(initialAuthService),
      _useState2 = (0, _slicedToArray3.default)(_useState, 1),
      authService = _useState2[0];

  var _useState3 = (0, _react.useState)(authService.getAuthState()),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      authState = _useState4[0],
      setAuthState = _useState4[1];

  (0, _react.useEffect)(function () {
    var unsub = authService.on('authStateChange', function () {
      setAuthState(authService.getAuthState());
    });
    authService.updateAuthState(); // Trigger an initial change event to make sure authState is latest

    return unsub;
  }, [authService]);
  return _react2.default.createElement(_OktaContext2.default.Provider, {
    value: {
      authService: authService,
      authState: authState
    }
  }, props.children);
};
/*
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */


exports.default = Security;